import { useState } from 'react';
import {
  Tr,
  Td,
  Button,
  Image,
  Icon,
  Badge,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import {
  NavButton,
  TablesReport,
  useAttendanceTableQuery,
} from '@/features/reports_mock';
import { ReportsIcon } from '@/assets/svgs';
import { FiBarChart2 } from 'react-icons/fi';
import { GenericModal } from '@/features/instances';
import {
  DashboardArModal,
  DashboardModal,
  DashboardRecModal,
} from '../Modals/DashboardModal';

export function ReportsTable() {
  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <>
      {' '}
      <TablesReport head={['NOME DO QUESTIONÁRIO', 'AÇÕES']}>
        <Tr key={1}>
          <Td>COPSOQ III</Td>
          <Td>
            <NavButton
              borderColor="#4ECDC4"
              borderWidth={2}
              label="Dashboard"
              color="#4ECDC4"
              leftIcon2={<Icon as={FiBarChart2} />}
              onClick={() => setOpenModal('cop')}
            />
          </Td>
        </Tr>
        <Tr key={1}>
          <Td>RED/DIC</Td>
          <Td>
            <NavButton
              borderColor="#4ECDC4"
              borderWidth={2}
              label="Dashboard"
              color="#4ECDC4"
              leftIcon2={<Icon as={FiBarChart2} />}
              onClick={() => setOpenModal('red')}
            />
          </Td>
        </Tr>
        <Tr key={1}>
          <Td>Qualidade do Ar</Td>
          <Td>
            <NavButton
              borderColor="#4ECDC4"
              borderWidth={2}
              label="Dashboard"
              color="#4ECDC4"
              leftIcon2={<Icon as={FiBarChart2} />}
              onClick={() => setOpenModal('ar')}
            />
          </Td>
        </Tr>
      </TablesReport>
      <Flex w="auto">
        <Modal
          isOpen={!!openModal}
          onClose={() => setOpenModal(null)}
          size="4xl"
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody px="12" pb="8">
              {openModal === 'cop' ? (
                <DashboardModal onCancel={() => setOpenModal(null)} />
              ) : openModal === 'red' ? (
                <DashboardRecModal onCancel={() => setOpenModal(null)} />
              ) : (
                <DashboardArModal onCancel={() => setOpenModal(null)} />
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      </Flex>
    </>
  );
}
